import React from 'react';
import moment from 'moment';
import { DatePickerInput } from 'rc-datepicker';
import { Field, ButtonRadio, Select } from '../Common';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

class AlternateMemoryChargedForm extends React.Component {
    constructor(props) {
        super(props);
		
		const parseDateFromInstant = (dateNaissance) => {
            if (!dateNaissance) return null;
            
            if (moment.isMoment(dateNaissance)) {
                return dateNaissance;
            }
            
            if (dateNaissance.epochSecond) {
                return moment.unix(dateNaissance.epochSecond).startOf('day');
            }
            
            if (typeof dateNaissance === 'string' && moment(dateNaissance).isValid()) {
                return moment(dateNaissance).startOf('day');
            }
            
            return null;
        };
		
		const dateNaissance = this.props.alternateMemoryChargedData && this.props.alternateMemoryChargedData.dateNaissance;
		const date = parseDateFromInstant(dateNaissance);
		
        this.state = {
            date: date,
            startDate: moment(),
            calendarFocused: false,
            firstName: this.props.alternateMemoryChargedData && this.props.alternateMemoryChargedData.prenom ? this.props.alternateMemoryChargedData.prenom : '',
            name: this.props.alternateMemoryChargedData && this.props.alternateMemoryChargedData.nom ? this.props.alternateMemoryChargedData.nom : '',
            email: this.props.alternateMemoryChargedData && this.props.alternateMemoryChargedData.email ? this.props.alternateMemoryChargedData.email : '',
            telephone: this.props.alternateMemoryChargedData && this.props.alternateMemoryChargedData.telephone ? this.props.alternateMemoryChargedData.telephone : '',
            address: this.props.alternateMemoryChargedData && this.props.alternateMemoryChargedData.address ? this.props.alternateMemoryChargedData.address : '',
            zipCode: this.props.alternateMemoryChargedData && this.props.alternateMemoryChargedData.zipCode ? this.props.alternateMemoryChargedData.zipCode : '',
            city: this.props.alternateMemoryChargedData && this.props.alternateMemoryChargedData.city ? this.props.alternateMemoryChargedData.city : '',
            codeCountry: this.props.alternateMemoryChargedData && this.props.alternateMemoryChargedData.codeCountry ? this.props.alternateMemoryChargedData.codeCountry : "79",
            alternateCharged: this.props.alternateMemoryChargedData &&  this.props.alternateMemoryChargedData.nom ? '1' : '0' ,
            error: {
                name: '',
                address: '',
                email: '',
                telephone: '',
                zipCode: '',
                city: '',
                date: '',
                codeCountry: '',
            }
        }
        this.handleChange = this.handleChange.bind(this)
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

	dateOnChange = (jsDate, dateString) => {

		let momentDate = null;
		
		if (jsDate instanceof Date && !isNaN(jsDate)) {
			momentDate = moment(jsDate).startOf('day');
		} else if (moment.isMoment(jsDate) && jsDate.isValid()) {
			momentDate = jsDate.startOf('day');
		}
		
		let obj = {}
		obj.date = (!momentDate || !momentDate.isValid()) ? 'is-invalid' : ''
		
		this.setState(prevState => ({
			date: momentDate, 
			error: {
				...prevState.error,
				...obj
			}
		}));
	}

    handleChange(value) {
        this.setState({ date: value })
    }
    onZipCodeChange(key, e) {
        const value = e.target.value;
        if (!isNaN(value)) {
            this.setState(() => ({ [key]: value }));
        }
    }
    handleOnChange(key, e) {
        const value = e.target.value;
            this.setState(() => ({ [key]: value }));
    }

    onDateChange = (date) => {
        if (date) {
            this.setState(() => ({ date }));
        }
    };
    onFocusChange = ({ focused }) => {
        this.setState(() => ({ calendarFocused: focused }));
    };

    onSubmit = (e) => {
        e.preventDefault();
        //if (this.state.addAlternate === '1') {
        const name = (!this.state.name) ? ' is-invalid' : '';
        const firstName = (!this.state.firstName) ? ' is-invalid' : '';
        const date = (!this.state.date || !moment.isMoment(this.state.date) || !this.state.date.isValid()) ? ' is-invalid' : '';
		const dateToSend = this.state.date ? this.state.date.format('YYYY-MM-DD') : null;
        const address = (!this.state.address) ? ' is-invalid' : '';
        const zipCode = (!this.state.zipCode) ? ' is-invalid' : '';
        const city = (!this.state.city) ? ' is-invalid' : '';
        const codeCountry = (!this.state.codeCountry) ? ' is-invalid' : '';
        const email = (!this.state.email) ? ' is-invalid' : '';
        const telephone = (!this.state.telephone) ? ' is-invalid' : '';
        this.setState(prevState => ({
            error: {
                ...prevState.error,
                name,
                firstName,
                date,
                email,
                telephone,
                address,
                zipCode,
                city,
            }
        }))
        if (this.state.alternateCharged === '1') {
                   
            if (!name && !firstName && !date && !address && !zipCode && !city && !codeCountry && !telephone && !email)
                this.props.onAlternateMemoryChargedSubmit({
                    firstName: this.state.firstName,
                    name: this.state.name,
                    date: dateToSend,
                    address: this.state.address,
                    zipCode: this.state.zipCode,
                    city: this.state.city,
                    email: this.state.email,
                    telephone: this.state.telephone,
                    codeCountry: this.state.codeCountry,
                    alternateCharged : this.state.alternateCharged

                });
        }
        else {
            this.props.onAlternateMemoryChargedSubmit({
                firstName: '',
                name: '',
                date: '',
                address: '',
                zipCode: '',
                city: '',
                email: '',
                telephone: '',
                codeCountry: '',
                alternateCharged :'0'
            });
        }
    }
    render() {
        const countryList = this.props.countryData.list;
        return (
            <form onSubmit={this.onSubmit}>
                <p>
                    Nous vous recommandons de designer un chargé de mémoire suppléant qui pourra remplacer le chargé principal.<br />
                    Souhaitez-vous désigner un chargé de mémoire suppléant?
                </p>
                <div className="alternate-radio-buttons">
                    <ButtonRadio
                        type="radio"
                        _id="radioAlternate1"
                        name="alternateCharged"
                        value="1"
                        checked={this.state.alternateCharged == "1"}
                        onChange={this.handleOnChange.bind(this, "alternateCharged")}
                        label="Oui"
                    />
                    <ButtonRadio
                        type="radio"
                        _id="radioAlternate2"
                        name="alternateCharged"
                        value="0"
                        checked={this.state.alternateCharged == "0"}
                        onChange={this.handleOnChange.bind(this, "alternateCharged")}
                        label="Non"
                    />
                </div>
                {this.state.alternateCharged === '1' &&
                	<h4>Je désigne comme Chargé de mémoire suppléant </h4>
                }
                {this.state.alternateCharged === '1' &&

                    <div className="row">
                        <div className="col-sm-5">
                            <img src='/images/b2-page-lg.png' alt="image profil" className=" _lg" />
                            <img src='/images/b2-page-sm.png' alt="image profil" className=" _sm" />
                        </div>
                        <div className="col-sm-7 form-container top-form">
                            <Field
                                label="Nom *"
                                type="text"
                                _className={"form-control  " + this.state.error.name}
                                value={this.state.name}
                                onChange={this.handleOnChange.bind(this, "name")}
                                error={this.state.error.name}

                            />
                            <Field
                                label="Prénom *"
                                type="text"
                                //placeholder="ALAIN"
                                _className={"form-control  " + this.state.error.firstName}
                                value={this.state.firstName}
                                onChange={this.handleOnChange.bind(this, "firstName")}
                                error={this.state.error.firstName}

                            />
                            <div className="form-group">
                                <label>Date de naissance *</label>
                                <DatePickerInput
                                    onChange={this.dateOnChange}
                                    value={this.state.date}
                                    maxDate={moment()}
                                    className={'custom-datepicker ' + this.state.error.date}
                                    showOnInputClick={true}
                                    iconClassName='cal-icon'
                                    locale = 'fr'
                                />
                                {this.state.error.date &&
                                    <div className="invalid-feedback invalid-date">
                                        Le champ Date de naissance *  est obligatoire
                            </div>
                                }
                            </div>
                            <Field
                                label="Email *"
                                type="email"
                                _className={"form-control  " + this.state.error.email}
                                value={this.state.email}
                                onChange={this.handleOnChange.bind(this, "email")}
                                error={this.state.error.email}

                            />
                            <Field
                                label="Numéro de téléphone*"
                                type="text"
                                _className={"form-control  " + this.state.error.telephone}
                                value={this.state.telephone}
                                onChange={this.handleOnChange.bind(this, "telephone")}
                                error={this.state.error.telephone}

                            />
                            <Field
                                label="Adresse *"
                                type="text"
                                _className={"form-control  address" + this.state.error.address}
                                value={this.state.address}
                                onChange={this.handleOnChange.bind(this, "address")}
                                error={this.state.error.address}
                            //placeholder="1 rue de Charles de Gaule"
                            />
                            <Field
                                label="Code postal *"
                                type="text"
                                _className={"form-control  " + this.state.error.zipCode}
                                value={this.state.zipCode}
                                onChange={this.onZipCodeChange.bind(this, "zipCode")}
                                error={this.state.error.zipCode}
                            //placeholder="97860"
                            />
                            <Field
                                label="Ville *"
                                type="text"
                                _className={"form-control  " + this.state.error.city}
                                value={this.state.city}
                                onChange={this.handleOnChange.bind(this, "city")}
                                error={this.state.error.city}
                            //placeholder="MARNY SUR OISE"
                            />
                            <Select
                                label="Pays *"
                                error={this.state.error.codeCountry}
                                _className={"form-control address " + this.state.error.codeCountry}
                                value={this.state.codeCountry}
                                onChange={this.handleOnChange.bind(this, 'codeCountry')}
                                list={countryList}
                                selectType="obj"
                                optionValue="id"
                                optionLabel="libelle"
                            />
                            <h5>Vous devrez informer cette personne de sa mission</h5>
                            <div className="required-txt"> * Champs obligatoires</div>

                        </div>
                    </div>
                }
                <div className="col-sm-12 button-container ">
                    <button type="button" onClick={this.props.back} className="btn btn-outline-primary" >{'< Precedent'}</button>
                    <button type="submit" className="btn btn-primary ">Suivant ></button>
                </div>
            </form>
        )
    }
}


const mapStateToProps = state => {
    return {
        alternateMemoryChargedData: state.alternateMemroyChargedData,
        countryData: state.countryData
    }
}

export default connect(mapStateToProps)(AlternateMemoryChargedForm);


// WEBPACK FOOTER //
// ./src/components/MemoryChargedPage/AlternateMemoryChargedForm.js